export default "__VITE_ASSET__DanTfBjv__"